import { EntityTemplateVariables } from '@tools/interfaces/template';
import { templateOrder, templateOrderItem } from './template-order-and-order-items';
import { getActivityFieldsForEntity } from '@tools/config/template-activity';
import { getActivityGroupFieldsForEntity } from '@tools/config/template-activity-group';
import { getContactFieldsForEntity } from '@tools/config/template-contact';

export const templateAttendee: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.attendees.code.label',
      contentValue: '{{ activity_session_attendee.code }}',
      description: 'templates.attendees.code.description',
    },
    {
      label: 'templates.attendees.status.label',
      contentValue: '{{ activity_session_attendee.status }}',
      description: 'templates.attendees.status.description',
    },
    {
      label: 'templates.attendees.comment.label',
      contentValue: '{{ activity_session_attendee.comment }}',
      description: 'templates.attendees.comment.description',
    },
    {
      label: 'templates.attendees.cancel_reason.label',
      contentValue: '{{ activity_session_attendee.cancel_reason }}',
      description: 'templates.attendees.cancel_reason.description',
    },
    {
      label: 'templates.attendees.cancel_reason_description.label',
      contentValue: '{{ activity_session_attendee.cancel_reason_description }}',
      description: 'templates.attendees.cancel_reason_description.description',
    },
    {
      label: 'templates.attendees.attendance.label',
      contentValue: '{{ activity_session_attendee.attendance }}',
      description: 'templates.attendees.attendance.description',
    },
    {
      label: 'templates.attendees.late_attendance.label',
      contentValue: '{{ activity_session_attendee.late_attendance }}',
      description: 'templates.attendees.late_attendance.description',
    },
    {
      label: 'templates.attendees.summoned.label',
      contentValue: '{{ activity_session_attendee.summoned }}',
      description: 'templates.attendees.summoned.description',
    },
    {
      label: 'templates.attendees.coming.label',
      contentValue: '{{ activity_session_attendee.coming }}',
      description: 'templates.attendees.coming.description',
    },
    {
      label: 'templates.attendees.excused.label',
      contentValue: '{{ activity_session_attendee.excused }}',
      description: 'templates.attendees.excused.description',
    },
    {
      label: 'templates.attendees.not_coming_reason.label',
      contentValue: '{{ activity_session_attendee.not_coming_reason }}',
      description: 'templates.attendees.not_coming_reason.description',
    },
    {
      label: 'templates.attendees.not_coming_reason_description.label',
      contentValue: '{{ activity_session_attendee.not_coming_reason_description }}',
      description: 'templates.attendees.not_coming_reason_description.description',
    },
    {
      label: 'templates.attendees.trip.label',
      contentValue: '{{ activity_session_attendee.trip }}',
      description: 'templates.attendees.trip.description',
    },
    {
      label: 'templates.attendees.available_places.label',
      contentValue: '{{ activity_session_attendee.available_places }}',
      description: 'templates.attendees.available_places.description',
    },
  ],
  related: [
    {
      relationName: 'bpcActivity',
      relationType: 'simple',
      label: 'templates.attendees.activity.label',
      description: 'templates.attendees.activity.description',
      fields: getActivityFieldsForEntity('activity_session_attendee.'),
    },
    {
      relationName: 'activityGroup',
      relationType: 'simple',
      label: 'templates.attendees.activity_group.label',
      description: 'templates.attendees.activity_group.description',
      fields: getActivityGroupFieldsForEntity('activity_session_attendee.'),
    },
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.attendees.contact.label',
      description: 'templates.attendees.contact.description',
      fields: getContactFieldsForEntity('activity_session_attendee.'),
    },
    {
      relationName: 'activitySession',
      relationType: 'simple',
      label: 'templates.attendees.activity_session.label',
      description: 'templates.attendees.activity_session.description',
      fields: [
        {
          label: 'templates.activity_sessions.code.label',
          contentValue: '{{ activity_session_attendee.activitySession.code }}',
          description: 'templates.activity_sessions.code.description',
        },
        {
          label: 'templates.activity_sessions.name.label',
          contentValue: '{{ activity_session_attendee.activitySession.name }}',
          description: 'templates.activity_sessions.name.description',
        },
        {
          label: 'templates.activity_sessions.start_date_time.label',
          contentValue:
            '{{ activity_session_attendee.activitySession.start_date_time | date("d/m/Y H:i") }}',
          description: 'templates.activity_sessions.start_date_time.description',
        },
        {
          label: 'templates.activity_sessions.attendees_start_date_time.label',
          contentValue:
            '{{ activity_session_attendee.activitySession.attendees_start_date_time | date("d/m/Y") }}',
          description: 'templates.activity_sessions.attendees_start_date_time.description',
        },
        {
          label: 'templates.activity_sessions.attendees_end_date_time.label',
          contentValue:
            '{{ activity_session_attendee.activitySession.attendees_end_date_time | date("d/m/Y") }}',
          description: 'templates.activity_sessions.attendees_end_date_time.description',
        },
        {
          label: 'templates.activity_sessions.min_participants.label',
          contentValue: '{{ activity_session_attendee.activitySession.min_participants }}',
          description: 'templates.activity_sessions.min_participants.description',
        },
        {
          label: 'templates.activity_sessions.max_participants.label',
          contentValue: '{{ activity_session_attendee.activitySession.max_participants }}',
          description: 'templates.activity_sessions.max_participants.description',
        },
      ],
    },
  ],
  relatedInLoop: [
    {
      relationName: 'orders',
      relationType: 'inLoop',
      label: 'templates.attendees.orders.label',
      description: 'templates.attendees.orders.description',
      blockStartValue: '{% for order in activity_session_attendee.orders %}',
      contentValue: '{# Add some order fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateOrder.fields,
    },
    {
      relationName: 'orderItems',
      relationType: 'inLoop',
      label: 'templates.attendees.order_items.label',
      description: 'templates.attendees.order_items.description',
      blockStartValue:
        '{% for order in activity_session_attendee.orders %}\n{% for orderItem in order.orderItems %}',
      contentValue: '{# Add some orderItem fields #}',
      blockEndValue: '{% endfor %}\n{% endfor %}',
      fields: templateOrderItem.fields,
    },
  ],
};
